import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import {
  CrudService, CrudType,
  LoggedInUserModel,
  ModulesBasedApiSuffix,
  OnDemandPreloadService,
  RxjsService,
  addDefaultTableObjectProperties,
  currentComponentPageBasedPermissionsSelector$,
  onActionSubmittedUtil,
  prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams
} from '@app/shared';
import { CustomerModuleApiSuffixModels } from '@modules/customer/shared/utils/customer-module.enums';
import { DealerModuleApiSuffixModels } from '@modules/dealer/shared/enum/dealer.enum';
import { MY_TASK_COMPONENTS } from '@modules/my-tasks/shared/utils/task-list.enum';
import { loggedInUserData } from '@modules/others/auth.selectors';
import { SalesModuleApiSuffixModels } from '@modules/sales';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
@Component({
  selector: 'app-my-customer-list',
  templateUrl: './my-customer-list.component.html'
})
export class MyCustomerListComponent extends PrimeNgTableVariablesModel implements OnInit {

  constructor(private crudService: CrudService, private rxjsService: RxjsService,
    private store: Store<AppState>, private router: Router,
    private activatedRoute: ActivatedRoute, private preloadOnDemandService: OnDemandPreloadService) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: 'DOA Dashboard',
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'My Task' }, { displayName: 'My Customer' },
      { displayName: 'My DOA' }, { displayName: 'Save Offer DOA' }],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Save Offer DOA',
            dataKey: 'requestNumber',
            enableSecondHyperLink: true,
            cursorSecondLinkIndex: 5,
            columns: [
              { field: 'requestNumber', header: 'Req No', width: '150px' },
              { field: 'requestDate', header: 'Req Date', width: '150px', isDateTime: true },
              { field: 'requestor', header: 'Requestor', width: '150px' },
              { field: 'requestType', header: 'Offer Type', width: '150px' },
              { field: 'requestorRole', header: 'Req Role', width: '150px' },
              { field: 'customerName', header: 'Customer Name and Surname', width: '150px' },
              { field: 'regionName', header: 'Region', width: '150px' },
              { field: 'branchName', header: 'Branch', width: '150px' },
              { field: 'suburbName', header: 'Suburb', width: '150px' },
              { field: 'serviceValue', header: 'Service Value', width: '150px' },
              { field: 'discountValue', header: 'Discount Value', width: '150px' },
              { field: 'discountPercentage', header: 'Discount Percentage', width: '150px' },
            ],
            apiSuffixModel: CustomerModuleApiSuffixModels.SAVE_OFFER_APPROVAL_DASHBOARD,
            moduleName: ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT
          },
          {
            caption: 'Suspension DOA',
            dataKey: 'serviceSuspendRefNo',
            columns: [
              { field: 'serviceSuspendRefNo', header: 'Req No', width: '150px' },
              { field: 'createdDate', header: 'Req Date', width: '150px', isDateTime: true },
              { field: 'displayName', header: 'Requestor', width: '150px' },
              { field: 'roleName', header: 'Req Role', width: '150px' },
              { field: 'customerName', header: 'Customer Name and Surname', width: '250px' },
              { field: 'suburbName', header: 'Suburb', width: '150px' },
              { field: 'suspensionMonthInterval', header: 'Suspension Month', width: '160px' },
            ],
            apiSuffixModel: SalesModuleApiSuffixModels.SERVICE_SUSPEND_DOA_APPROVAL_LIST,
            moduleName: ModulesBasedApiSuffix.SALES
          },
        ]
      }
    }
    this.selectedTabIndex = this.activatedRoute.snapshot.queryParams?.tab ? +this.activatedRoute.snapshot.queryParams?.tab : 0;
    this.primengTableConfigProperties.breadCrumbItems[3].displayName = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].caption;
    this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties, [{ index: 0, propertyName: 'enableFieldsSearch' }]);
  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData();
    this.getListData();
    this.preloadOnDemandService.startPreload('customer');
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties, [{ index: 0, propertyName: 'enableFieldsSearch' },
      { index: 1, propertyName: 'enableFieldsSearch' }]);
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      let permission = response[1][MY_TASK_COMPONENTS.MY_CUSTOMER]
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, permission);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
        this.selectedTabIndex = this.selectedTabIndex == 0 ? prepareDynamicTableTabsFromPermissionsObj['selectedTabIndex'] : this.selectedTabIndex || 0;
      }
    });
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  onTabChange(event) {
    this.loading = false;
    this.dataList = [];
    this.totalRecords = null;
    this.selectedTabIndex = event.index;
    this.router.navigate(['/my-tasks', 'my-customer'], { queryParams: { tab: this.selectedTabIndex } });
    this.getListData();
    this.primengTableConfigProperties.breadCrumbItems[3].displayName = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].caption;
  }

  onCRUDRequested(type: CrudType | string, row?: object | any, unknownVar?: any): void {
    switch (type) {
      case CrudType.CREATE:
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        this.row = row ? row : { pageIndex: 0, pageSize: 10 };
        this.first = row?.pageIndex && row?.pageSize ? row["pageIndex"] * row["pageSize"] : 0;
        this.getListData(this.row["pageIndex"], this.row["pageSize"], unknownVar)
        break;
      case CrudType.VIEW:
        this.openAddEditPage(CrudType.VIEW, row);
        break;
      case CrudType.EDIT:
        // Get the current query parameters to preserve fromComponent
        const currentQueryParams = this.activatedRoute.snapshot.queryParams;

        this.rxjsService.setViewCustomerData({
          customerId: row['customerId'],
          addressId: row['addressId'],
          customerTab: 0,
          monitoringTab: null,
          fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
        })
        this.rxjsService.navigateToViewCustomerPage();
        break;
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | any, index?: number): void {
    switch (type) {
      case CrudType.VIEW:
        switch (this.selectedTabIndex) {
          case 0:
            if (editableObject?.requestType == "Upgrade") {
              this.router.navigate(['/customer/manage-customers/customer-service-upgrade-downgrade/upgrade/doa-action'], { queryParams: { id: editableObject?.saveOfferId, contractId: editableObject?.contractId } })
            } else if (editableObject?.requestType == "Downgrade") {
              this.router.navigate(['/customer/manage-customers/customer-service-upgrade-downgrade/downgrade/doa-action'], { queryParams: { id: editableObject?.saveOfferId, contractId: editableObject?.contractId } })
            } else {
              this.router.navigate(['my-tasks/my-customer/save-offer'], { queryParams: { id: editableObject?.saveOfferId, contractId: editableObject?.contractId, customerId: editableObject?.customerId, addressId: editableObject?.siteAddressId, saveOfferDOAApprovalId: editableObject?.saveOfferDOAApprovalId, } });
            }
            break;
          case 1:
            this.router.navigate(['my-tasks/my-customer/suspension'], {
              queryParams: {
                id: editableObject?.serviceSuspendId, contractId: editableObject?.contractId, customerId: editableObject?.customerId, addressId: editableObject?.siteAddressId,
                processName: "SuspensionDOA",
              }
            });
            break;
        }
        break;
    }
  }

  getListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    this.rxjsService.setGlobalLoaderProperty(true);
    otherParams = { ...otherParams, userId: this.loggedInUserData.userId };
    let dealerModuleApiSuffixModels: DealerModuleApiSuffixModels;
    dealerModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    const moduleName = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].moduleName;
    this.crudService.get(
      moduleName,
      dealerModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe(data => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.dataList = data.resources;
        this.totalRecords = data.totalCount;
      } else {
        this.dataList = null;
        this.totalRecords = 0;
      }
    });
  }

  onChangeSelecedRows(e) {
    this.selectedRows = e;
  }
}
